// extracted by mini-css-extract-plugin
module.exports = {"board":"Board_board__1Y7VT","boardItem":"Board_boardItem__1dn5J","link":"Board_link__21UVk","activeItem":"Board_activeItem__3bG7E"};